module.exports = __webpack_public_path__ + "img/Cameroon.fbcdf805.png";